import { render, staticRenderFns } from "./AssessmentResultsDetail.vue?vue&type=template&id=0bcce21b&scoped=true"
import script from "./AssessmentResultsDetail.vue?vue&type=script&lang=js"
export * from "./AssessmentResultsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcce21b",
  null
  
)

export default component.exports